import api from "@/services/api";
import { DashboardDateRangeParams } from "@/interfaces/DashboardDossierStats";
import { DashboardDossierUserStatsResponse } from "@/interfaces/DashboardDossierUserStats";

export const dashboardDossierUserStatsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDashboardDossierUserStats: build.query<
      DashboardDossierUserStatsResponse,
      DashboardDateRangeParams
    >({
      query: (params) => ({
        url: "/admin/stats/dossiers/by-user",
        params,
      }),
      providesTags: [{ type: "DashboardStats", id: "DOSSIERS_BY_USER" }],
    }),
  }),
  overrideExisting: true,
});

export const { useGetDashboardDossierUserStatsQuery } =
  dashboardDossierUserStatsApi;
